import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { BlockLink } from "@/views/blocks/PageBlock.interface";
import { handleHashNavigation } from "@/shared/utils/router/hashNavigation";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigationItem',
  props: {
    href: {},
    label: {},
    textColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "17b622a2": (_ctx.textColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.href,
    class: "link-item text-sm/6",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleHashNavigation) && _unref(handleHashNavigation)(...args)))
  }, _toDisplayString(_ctx.label), 9, _hoisted_1))
}
}

})